<ng-container *ngIf="(!showContentTab && !foundSearchResults && hasQueryText)">

  <div class="row no-gutters mb-5 mb-empty-search-result"
       data-cy="mb-empty-search-result"
  >

    <div class="col-12 col-lg-8 text-center mx-auto my-auto">
      <div class="mt-3 mb-4">
        <strong>{{ 'searchResultItem.emptyResultTitle' | mbTranslate }}</strong>
      </div>
      <div>{{ 'searchResultItem.emptyResultLine1' | mbTranslate }}</div>
      <div class="mb-3">{{ 'searchResultItem.emptyResultLine2' | mbTranslate }}</div>
    </div>

  </div>
</ng-container>
